import { CSSProperties } from "react";
import { AnyAction, Middleware, UnknownAction } from "redux";

import { ClassroomSliceStateType } from "./classroom";
import { MonitoringSliceStateType } from "./monitoring";
import { PageUnloadReasonType, PubsubStatsCollectorType } from "./pubsub";

export * from "./classroom";
export * from "./local";
export * from "./monitoring";
export * from "./persistence";
export * from "./pubsub";
export * from "./redux";

declare global {
  interface Window {
    FLAGS: FlagRecordType;
    Settings: object;
    flightLogger: LoggerType;
    flightStore?: any;
    markRecordingStarted: () => void;
    pageUnloadReason?: PageUnloadReasonType;
    pubsubStatsCollector: PubsubStatsCollectorType;
    _env_: {
      // Keep in sync with public/config.js and /config
      COMMIT: string;
      DATADOG_CLIENT_TOKEN: string;
      DATADOG_ENABLED: boolean;
      ENV: string;
      FORUM_URL: string;
      GOOGLE_DRIVE_DOMAIN: string;
      INTERCOM_APP_ID: string;
      INTERCOM_ENABLED: boolean;
      MINERVA_RESOURCES_ENVIRONMENT: string;
      MINERVA_RESOURCES_URL: string;
      ROLLBAR_ACCESS_TOKEN: string;
      ROLLBAR_ENABLED: boolean;
      S3_BUCKET_BUG_REPORTS_NAME: string;
      S3_BUCKET_BUG_REPORTS_REGION: string;
      S3_BUCKET_EMOJIS_NAME: string;
      S3_BUCKET_EMOJIS_REGION: string;
      S3_BUCKET_PICTURES_NAME: string;
      S3_BUCKET_PICTURES_REGION: string;
      TLD: string;
    };
  }
}

// This is necessary so we can have our global "version" variable on an object we didn't define
// TypeScript 5.9 requires a different approach for module augmentation
export interface VersionedStore {
  version: number;
}

// Other types //

export interface ActionLogType {
  action: UnknownAction;
  timestamp: number;
}

export type ActiveUserIdsType = {
  [channel: string]: string[];
};

export type DropdownOptionType = {
  label: string;
  value: number | string;
};

export enum FlagNameType {
  DISABLE_MONITORING_EVENTS = "disable-monitoring-events",
  DISABLE_NON_ESSENTIAL_MONITORING_EVENTS = "disable-non-essential-monitoring-events",
}

export type FlagRecordType = Record<FlagNameType, string[]>;

export type FlightServerType = {
  id: number;
  hostname_prefix: string;
  is_available: boolean;
  is_monitoring_server: boolean;
  group: string;
};

export enum GoogleMimetypeType {
  Document = "document",
  Drawing = "drawing",
  Spreadsheet = "spreadsheet",
}

export interface LoggerType {
  actionLogger: Middleware;
  bufferedLog: (args: unknown[], type: "log" | "warn" | "error") => void;
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  actionLogArray: () => ActionLogType[];
  consoleLogArray: () => LogType[];
}

export interface LogType {
  msg: string;
  timestamp: number;
  type: "log" | "warn" | "error";
  error?: Error;
}

export type PermissionHandlerType = (
  classId: string,
  userId: string,
  state: ClassroomSliceStateType | MonitoringSliceStateType,
  action: AnyAction,
  flags: Partial<FlagRecordType>,
) => boolean;

export type S3BucketType = {
  NAME: string;
  REGION: string;
};

export type SizeType = "xs" | "sm" | "md" | "lg" | "xl";

// TODO: Move this to FDS
export type IconPropsType = {
  size?: SizeType;
  color?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  viewBox?: string;
  style?: CSSProperties;
};
